import { call, put } from 'redux-saga/effects';

import * as action from '../../actions';
import * as actNotif from '../../actions/notifications';

import * as api from '../../api/refunds/index';
import { assertErrorHasMessage } from '../../utils/assert';

export function* post(callGenerator: ReturnType<typeof call>) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  try {
    const response = yield callGenerator;
    return response.data;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.hideProgressBar());
  }
}

export function* postRefundV2(data: Parameters<typeof api.postRefundv2>[0]) {
  yield* post(call(api.postRefundv2, data));
}

export function* postRefund(data) {
  yield* post(call(api.postRefund, data));
}

export function* postOldRefund(data) {
  yield* post(call(api.postOldRefund, data));
}
